import { render, staticRenderFns } from "./RecieverInfoEdit.vue?vue&type=template&id=fa35009e&scoped=true"
import script from "./RecieverInfoEdit.vue?vue&type=script&lang=js"
export * from "./RecieverInfoEdit.vue?vue&type=script&lang=js"
import style0 from "./RecieverInfoEdit.vue?vue&type=style&index=0&id=fa35009e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa35009e",
  null
  
)

export default component.exports